export default __webpack_public_path__ + "static/media/IMG_0054.6a35d99c.jpg";